export const SET_SEARCH_QUERY = 'query/SET_SEARCH_QUERY';
export const SET_MAP_COORDINATES = 'query/SET_MAP_COORDINATES';
export const SET_SELECTED_AREAS = 'query/SET_SELECTED_AREAS';
export const SET_CONCEPTS = 'query/SET_CONCEPTS';
export const SET_MODE = 'query/SET_MODE';
export const SET_DATA_SOURCES = 'query/SET_DATA_SOURCES';
export const SET_AGENTS = 'query/SET_AGENTS';
export const SET_START_END = 'query/SET_START_END';
